import { Avatar } from "~/components/Avatar";
import type { DirectoryCard } from "~/lib/api";

type Props = {
  member: DirectoryCard;
  onOpen: (id: string) => void;
};

export function CompanyPeopleRow(props: Props) {
  const name = () => props.member.display_name ?? "Member";
  const role = () => props.member.headline ?? props.member.job_role ?? "";

  return (
    <button type="button" class="company-people-row" onClick={() => props.onOpen(props.member.id)}>
      <Avatar url={props.member.avatar_url} name={name()} size="sm" />
      <span class="company-people-row-body">
        <strong>{name()}</strong>
        <span class="muted">{role()}</span>
      </span>
      <svg class="company-card-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </svg>
    </button>
  );
}
